export const PROFILE_UPDATED = 'app/Onboarding/PROFILE_UPDATED';
export const SIGNUP_CONFIRMED = 'app/SignUp/SIGNUP_CONFIRMED';
export const INVITE_CONFIRMED = 'app/SignUp/INVITE_CONFIRMED';
export const INVITES_HANDLED = 'app/SignUp/INVITES_HANDLED';
export const SET_HAS_BEEN_LEFT = 'app/SignUp/SET_HAS_BEEN_LEFT';
